<template>
    <div class="erreur-liste">
        <div v-for="erreur in erreurs"
             :key="erreur.idErreur"
             class="erreur-carte"
             :class="getCouleur(erreur.Type)">
            <div class="entete">
                <span class="type">{{ erreur.TypeName }}</span>
                <span class="etat" v-if="erreur.HasBeenSeen">✔ Vue</span>
                <span class="etat non-vue" v-else>⏺ Non vue</span>
            </div>
            <h3 class="titre">{{ erreur.Titre }}</h3>
            <p class="message">{{ erreur.Message }}</p>
        </div>
    </div>
</template>

<script>
export default {
        name: "ListeErreurTransCAM",
  props: {
    erreurs: {
      type: Array,
      required: true
    }
  },
  methods: {
    getCouleur(type) {
      switch (type) {
        case 1: return "info";           // Info
        case 2: return "avertissement";  // Avertissement
        case 3: return "erreur";         // Erreur
        case 4: return "critique";       // ErreurCritique
        default: return "inconnu";
      }
    }
        },
}
</script>

<style scoped>
    .erreur-liste {
        display: flex;
        flex-wrap: wrap;
        gap: 1rem;
        justify-content: center;
    }

    .erreur-carte {
        width: 300px;
        padding: 1rem;
        border-left: 6px solid;
        border-radius: 8px;
        background-color: #fff;
        box-shadow: 0 4px 8px rgba(0,0,0,0.08);
        transition: transform 0.2s;
    }

        .erreur-carte:hover {
            transform: translateY(-4px);
        }

    .entete {
        display: flex;
        justify-content: space-between;
        font-size: 0.9rem;
        margin-bottom: 0.5rem;
        font-weight: bold;
    }

    .titre {
        margin: 0;
        font-size: 1.2rem;
        color: #333;
    }

    .message {
        margin: 0.5rem 0 0;
        color: #555;
    }

    .etat {
        color: green;
    }

    .non-vue {
        color: #c00;
    }

    /* Couleurs selon le type */
    .info {
        border-color: #2196f3;
        background-color: #e3f2fd;
    }

    .avertissement {
        border-color: #ff9800;
        background-color: #fff3e0;
    }

    .erreur {
        border-color: #f44336;
        background-color: #ffebee;
    }

    .critique {
        border-color: #b71c1c;
        background-color: #ffebee;
    }

    .inconnu {
        border-color: #9e9e9e;
        background-color: #f5f5f5;
    }
</style>
